/**
 * SOLID Review
 * S — Strong. The scalar shapes every client schema shares, and nothing else.
 * O — Strong. A new scalar is a new export; nothing here changes for a new decision.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Three schemas, each one line.
 * D — Good. Depends on zod — the one dependency domain/ports/ may have besides the kernel
 *     (`domain-ports-only-zod-and-kernel`, frontend strict-ports plan FE0).
 */
import { z } from 'zod';

/**
 * WHAT CROSSES THE DOMAIN'S PORT (frontend strict-ports plan, FE1, 2026-10-03). The client twin of
 * `backend/src/domain/ports/schemas/primitives.ts`: JSON and nothing but JSON, so the Domain can run
 * on the far side of a `postMessage` with the same bytes it sees in-process (FE8's proof).
 *
 * TYPES, NOT RANGES. A decision's arguments and results are parsed by the kernel guard, and a parse
 * failure is a CONTRACT failure: the move is not applied and the table stalls. So these schemas say
 * what a value IS (an integer, a non-empty id) and never what it may be (1…6, a legal claim) — a
 * range is a game rule, and rules live in the decisions, where a violation is decided rather than
 * refused at the door. Nothing here is narrower than `@ml3d/contract`'s GraphQL types allow.
 */

/** An id the server minted for an `ID!` field: never empty. */
export const Identifier = z.string().min(1);
/** A Meyer RANK — 32…65, 110…160, 900, 1000 — or 0 for "no floor". Not the two-digit dice value. */
export const MeyerRank = z.number().int();
/** One die as the server reports it. 0 is "no dice" — a reveal from an older server — which the cup-lift decision skips. */
export const DieFace = z.number().int();
